import React from "react";
import NoImage from "./NoImage";
import DOMPurify from "dompurify";
import "../Schedule/Schedule.css";

const Elements = ({ id, imagePath, location, address, title, artist, contents, date, open, door, start, adv, drink, etc }) => {

    const createSafeHTML = (html) => {
        return { __html: DOMPurify.sanitize(html) };
    };


    return (
        <div className="schedule-contents-wrapper" id={id}>

            <div className="schedule-contents-title-wrapper">
                <div className="schedule-contents-title-inner">
                    <div className="schedule-contents-date">
                        {date}
                    </div>
                    <div className="schedule-contents-location">
                        @{location}
                    </div>
                    <div className="schedule-contents-title">
                        【{title}】
                    </div>
                </div>
            </div>
            <div className="schedule-contents-body">
                <div className="schedule-image">
                    {imagePath ? <a href={imagePath} target="_blank"><img src={imagePath} alt={id} className="schedule-image-image" /> </a> : <NoImage />}
                </div>
                <div className="schedule-contents-contents">
                    日時：{date}<br />
                    会場：{location}<br />
                    {address}<br />
                    <br />
                    Open:{open}/Start:{start}<br />
                    adv:{adv}/door:{door}/{drink}<br />
                    {etc}<br />
                    <br />
                    出演：{artist}<br />
                    <br />
                    <div dangerouslySetInnerHTML={createSafeHTML(contents)} />
                 


                </div>


            </div>

        </div>

    );
}

export default Elements;